module.exports = __webpack_public_path__ + "static/img/2.bfc6c23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/eventBanner/2.jpg
// module id = cAxn
// module chunks = 9